import React from "react";
import { useTranslation } from "react-i18next";
import s from "./Welcome.module.scss";

const Welcome = () => {
  const { t } = useTranslation();

  return (
    <div className={s.welcomePageContainer}>
      <div className={s.welcome}>{t("page.welcome.title")}</div>
    </div>
  );
};

export default React.memo(Welcome);
